import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { BuilderWorkspacePage } from './BuilderWorkspace.page';
import TemplatePreviewPage from './TemplatePreview.page';
/**
 * FormConfigRouter - Encapsulates all form-config related routes
 * This component centralizes all form configuration routes in one place
 */
export const FormConfigRouter = () => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "templates/:orgId/:formKey", element: React.createElement(TemplatePreviewPage, null) }),
        React.createElement(Route, { path: ":formKey", element: React.createElement(BuilderWorkspacePage, null) })));
};
